import { customTitle } from '../../../../utils/customTitle';
import { ISeccionVideoProps } from '../seccionVideo';

function seccionVideoAdapter(data: any): ISeccionVideoProps {
    return {
        title: data.tituloGeneral ? customTitle(data.tituloGeneral) : '',
        video: data.video ? data.video : ''
    };
}

export default seccionVideoAdapter;
